export const BrokenUrlResultConstants = {
    FETCH_BROKEN_URL_RESULT_PENDING: 'FETCH_BROKEN_URL_RESULT_PENDING',
    FETCH_BROKEN_URL_RESULT_GET_LIST_SUCCESS: 'FETCH_BROKEN_URL_RESULT_GET_LIST_SUCCESS',
    FETCH_BROKEN_URL_RESULT_ERROR: 'FETCH_BROKEN_URL_RESULT_ERROR',
    FETCH_BROKEN_URL_RESULT_SET_PAGE: 'FETCH_BROKEN_URL_RESULT_SET_PAGE',
    FETCH_BROKEN_URL_SET_APPROVE: 'FETCH_BROKEN_URL_SET_APPROVE',
    FETCH_BROKEN_URL_SET_SELECTED_LIST: 'FETCH_BROKEN_URL_SET_SELECTED_LIST',
    FETCH_BROKEN_URL_SET_ORIGINAL_LIST: 'FETCH_BROKEN_URL_SET_ORIGINAL_LIST',
};